import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Radio = (props: IconProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill={props.color || "#000"}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M8.0026 14.6663C4.3206 14.6663 1.33594 11.6817 1.33594 7.99967C1.33594 4.31767 4.3206 1.33301 8.0026 1.33301C11.6846 1.33301 14.6693 4.31767 14.6693 7.99967C14.6693 11.6817 11.6846 14.6663 8.0026 14.6663ZM8.0026 13.333C9.41709 13.333 10.7736 12.7711 11.7738 11.7709C12.774 10.7707 13.3359 9.41416 13.3359 7.99967C13.3359 6.58519 12.774 5.22863 11.7738 4.22844C10.7736 3.22824 9.41709 2.66634 8.0026 2.66634C6.58812 2.66634 5.23156 3.22824 4.23137 4.22844C3.23117 5.22863 2.66927 6.58519 2.66927 7.99967C2.66927 9.41416 3.23117 10.7707 4.23137 11.7709C5.23156 12.7711 6.58812 13.333 8.0026 13.333ZM8.0026 11.333C7.11855 11.333 6.2707 10.9818 5.64558 10.3567C5.02046 9.73158 4.66927 8.88373 4.66927 7.99967C4.66927 7.11562 5.02046 6.26777 5.64558 5.64265C6.2707 5.01753 7.11855 4.66634 8.0026 4.66634C8.88666 4.66634 9.7345 5.01753 10.3596 5.64265C10.9847 6.26777 11.3359 7.11562 11.3359 7.99967C11.3359 8.88373 10.9847 9.73158 10.3596 10.3567C9.7345 10.9818 8.88666 11.333 8.0026 11.333Z"
                fill={props.color || "#000"}
            />
        </svg>
    )
}

export default Radio
